import React from "react";
import cn from "classnames";
import {createUseStyles} from "react-jss";
import {brandColor, defaultFontSize} from "~/theme";
import UILink from "~/old-ui/UILink";
import ReactLink from "~/components/ReactLink";

export default function NavbarMenuItem({href, external, label, className}) {
  const classes = useStyles();

  return external ? (
    <UILink className={cn(classes.root, className)} href={href}>{label}</UILink>
  ) : (
    <ReactLink to={href} className={cn(classes.root, className)}>{label}</ReactLink>
  )
}

NavbarMenuItem.defaultProps = {
  external: true,
};

const useStyles = createUseStyles({
  root: {
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    padding: [[0, 6]],
    transition: [['all', '150ms', 'ease']],
    fontSize: defaultFontSize,
    borderBottom: 0,
    outline: 'none',

    '& + &': {
      marginLeft: 4,
    },

    '&:hover, &:focus': {
      color: brandColor,
      textDecoration: 'none',
      borderBottom: 0,
      outline: 'none',
    },
  }
});
